import React, {useState} from 'react';
import { Redirect } from 'react-router-dom';
import {
    TextInput,
    DateInput,
    SelectInput,
    Create,
    TabbedForm,
    FormTab,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    ImageInput,
    ImageField,
    BooleanInput,
    ArrayInput,
    SimpleFormIterator,
    useQueryWithStore
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Allergies from '../controls/Allergies'
import Referrls from './GetReferral'
import Iframe from '../controls/Iframe'
import IsNot2ndPhysical from './IsNot2ndPhysical'
import Sign from '../controls/Signature';
import SanitizedTextInput from '../controls/SanitizedTextInput';
import ErrorBoundary from '../ErrorBoundary';
const {  REACT_APP_CONSENT_URL } = process.env;

let ssn = null
var qDonorSign = null;
var qExaminerSign = null;
var aDonorSign = null;
var aExaminerSign = null;
var tDonorSign = null;
var tExaminerSign = null;
var cDonorSign = null;
var cExaminerSign = null;


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const PhysicalEditActions = ({props}) => (
    ssn = (props && props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn,
    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/physicals?filter=%7B"ssn"%3A"' + ssn +'"%7D&order=DESC&page=1&perPage=25&sort=id'} label='Physical List'/>
    </CardActions>
);


const leftRight = [
    {
        id: 'L',
        name: 'Left'
    },
    {
        id : 'R',
        name: 'Right'
    }
  ]
  const YesNoExt = [
    {
        id: 'Y',
        name: 'Yes'
    },
    {
        id : 'N',
        name: 'No'
    },
    {
        id : '/',
        name: 'N/A'
    }
  ]

  const YesNo = [
    {
        id: 'Y',
        name: 'Yes'
    },
    {
        id : 'N',
        name: 'No'
    }
  ]

const editStyles = {
    formTable: {
        margin: 'auto',
        width: '100%',
        fontSize: '12px',
        '& td': { padding: '6px 10px', verticalAlign: 'top' },
        '& tr:hover': { backgroundColor: 'transparent' },
        '& .MuiFormControl-root': { width: '100%' },
    },
    root: { alignItems: 'flex-start'},
    initial: {  width: '5em' },
    booth: {  width: '2em' },
    time: {  width: '7em' },
    volume: {  width: '3em' },
    comments: {  width: '30em' },
    inlineBlock: {
        display: 'inline-flex',
        margin: '5px',
        padding: '5px',
    },
};

  const location = [
    {
        id: 'Jacksonville',
        name: 'Jacksonville'
    },
    {
        id : 'MIAMI',
        name: 'MIAMI'
    }
  ]
const types = [
    {
        id : 'Applicant/New',
        name : 'Applicant/New'
    },
    {
        id: 'Annual',
        name: 'Annual'
    }
]

const anato = [
    {
        id: 'WNL',
        name: 'WNL'
    },
    {
        id: 'Abnomal',
        name: 'Abnomal'
    }
]


function showNext(val, id, to, validator){
    //alert(val)
    let i = 0;

    if(val === validator || val === "/"){
        document.getElementById("td_" + id).removeAttribute("style"); 
        for( i= id +1; i < id+to + 1;  i++)
            document.getElementById("hq_" + i).removeAttribute("style");
    }else{
        document.getElementById("td_" + id).setAttribute("style", "color: red;");
        for( i= id +1; i < 57;  i++)
            document.getElementById("hq_" + i).setAttribute("style", "display: none;");
    }
}

const AnotoValidate=(val,id) =>(
    (val === 'WNL')? document.getElementById("tc_" + id).removeAttribute("style"): document.getElementById("tc_" + id).setAttribute("style", "color: red;")
)



const PhysicalToolbar = props => (
    <Toolbar {...props} >
        
        <SaveButton
            label="save"    
            transform={data => ({ ...data, q_don_sign: qDonorSign, 
                q_exam_sign: qExaminerSign,
                a_don_sign: aDonorSign, 
                a_exam_sign: aExaminerSign,
                t_don_sign: tDonorSign, 
                t_exam_sign: tExaminerSign,
                c_don_sign: cDonorSign, 
                c_exam_sign: cExaminerSign    })}
            redirect={'/physicals?filter=%7B"ssn"%3A"' + ssn +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
            submitOnEnter={true}
        />
    </Toolbar>
);

const GetKey=({ props }) => (
    ssn = (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn,
    (ssn)? '': <Redirect to="/donors" />
);


const setQDonSignatureValue=(image)=>{
    qDonorSign = image;
}
const setQExaminerSignatureValue=(image)=>{
    qExaminerSign = image;
}
const setADonSignatureValue=(image)=>{
    aDonorSign = image;
}
const setAExaminerSignatureValue=(image)=>{
    aExaminerSign = image;
}
const setTDonSignatureValue=(image)=>{
    tDonorSign = image;
}
const setTExaminerSignatureValue=(image)=>{
    tExaminerSign = image;
}
const setCDonSignatureValue=(image)=>{
    cDonorSign = image;
}
const setCExaminerSignatureValue=(image)=>{
    cExaminerSign = image;
}

const PhysicalCreate =({ classes, ...props }) => (
<ErrorBoundary>    
<Create 
    title='Physical Exam | Add' 
    {...props}  
    actions={<PhysicalEditActions  props={props}/>} 
    >
    <TabbedForm toolbar={<PhysicalToolbar />}>      
        
            <FormTab label="Initial" id="init">         
                <GetKey props ={props}/>
                <Allergies ssn={ (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn} />   
                <Table   className={classes.formTable} >                           
                    <TableBody>                 
                        <TableRow>
                            <TableCell  align="left"><SelectInput source='type'  label="Type" choices={types}  validate={required()}/></TableCell>
                            <TableCell  align="left"><SanitizedTextInput  validate={required()} source="ssn" label="Donor #"   defaultValue={(props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn}   disabled /></TableCell>
                            <TableCell  align="left"><SelectInput source='location'  label="Location" choices={location}  validate={required()}/></TableCell>
                        </TableRow> 
                    </TableBody>
                </Table>
                <Table   className={classes.formTable} >                           
                    <TableBody>  
                        <TableRow>  
                            <TableCell  align="left"><SanitizedTextInput source="auditor" label="Auditor Present During Physical Donor Consent" fullWidth /></TableCell>
                            <TableCell  align="left"><SanitizedTextInput source="donor_init" label="Donor Initial"  /></TableCell>
                        </TableRow>  
                        <TableRow>  
                            <TableCell  align="left"><BooleanInput source="chap_offered" label="Chaperone Offered?" /></TableCell>
                            <TableCell  aling="left" ><TextInput source="chap_offered_comments" label="Comments"  rowsMax={3} multiline fullWidth /></TableCell>
                        </TableRow>  
                        <TableRow>  
                            <TableCell colSpan="2"  align="left"><BooleanInput source="flipchart" label="Have you read and understood the Flipchart?"   validate={required()} /></TableCell>
                        </TableRow>            
                    </TableBody>
                </Table>
            </FormTab>
            <FormTab label="History Questionnaire" id="hist">  
            <Allergies ssn={ (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn} />   
            <table cellPadding={8} style={{width: '100%'}}>
                    <tbody>
                        <tr >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;<b>Are you</b></td>
                        </tr>
                        <tr> 
                            <td  id ='td_1'>1.	Feeling healthy and well today? </td><td> <SelectInput style={{ float: "left"}} choices={YesNo}  source="f_healthy" label="" onChange={value => showNext(value.target.value, 1, 1,"Y")} validate={required()} /></td>
                        </tr>
                         <tr  style={{display: 'none'}}   id= 'hq_2' > 
                            <td id ='td_2'>2.	Currently taking an antibiotic or other medication for an infection? </td><td><SelectInput style={{ float: "left"}} choices={YesNo} onChange={value => showNext(value.target.value, 2, 1, "N")} source="f_antibiotic" label=""  /></td>
                        </tr >
                         <tr  style={{display: 'none'}}  id= 'hq_3' >
                            <td id ='td_3'>3.	Currently taking any other medications?</td>
                            <td><SelectInput choices={YesNo}  style={{ float: "left"}} source="f_other_med" label=""  onChange={value => showNext(value.target.value, 3, 2, "N")}/></td>
                        </tr>
                             <tr  style={{display: 'none'}}   id= 'hq_4' >
                                <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;<b>Please read the medication list.</b></td>
                            </tr>
                             <tr  style={{display: 'none'}}  id= 'hq_5' >
                                <td id ='td_5'>4.	Have you taken any medications on the medication list in the time frames indicated?</td>
                                <td><SelectInput choices={YesNo}  source="f_taken_med" label="" style={{ float: "left"}} onChange={value => showNext(value.target.value, 5, 2, "N")}   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_6' >
                                <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;<b>Please review the Risk Poster</b></td>
                            </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_6' > 
                            <td id ='td_6'>5.	Did you review the Risk Poster?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 6, 1, "Y")}  style={{ float: "left"}} choices={YesNo}  source="f_risk" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}   id= 'hq_7' > 
                            <td id ='td_7'>6.	Do you have any questions about anything mentioned on the Risk Poster?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 7, 2, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_quest_med" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_8' >
                            <td colSpan="2" bgcolor="silver" height="35">In the past <b>two months, have you </b></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_9' > 
                            <td id ='td_9'>7.	Had any vaccinations or other shots?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 9, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_vaccination" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_10'  > 
                            <td id ='td_10'>8.	Had contact with someone who was vaccinated for smallpox in the past 8 weeks?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 10, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_smallpox" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_11' > 
                            <td id ='td_11'>9. Donated whole blood, platelets or plasma at another center?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 11, 2, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_another_center" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_12' >
                                <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;In the past <b>three months</b>, have you</td>
                            </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_13' > 
                            <td id ='td_13'>10.	Had a blood transfusion or received other blood products?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 13, 1, "N")} style={{ float: "left"}} choices={YesNo}  source="f_transfusion" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_14' > 
                            <td id ='td_14'>11.	Come into contact with someone else's blood?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 14, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_contact_blood" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_15' > 
                            <td id ='td_15'>12. Had an accidental needle-stick involving exposure to blood?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 15, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_needle" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_16'> 
                            <td id ='td_16'>13.	Had sexual contact with anyone who has ever had HIV or has ever had a positive test for HIV virus?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 16, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_sex_contact_hiv" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_17'> 
                            <td id ='td_17'>14.	Received money, drugs, or other payment for sex?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 17, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_money_sex" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_18'> 
                            <td id ='td_18'>15. Had sexual contact with a prostitute or anyone else who takes money or drugs or other payment for sex?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 18, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_sex_contact_pay" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_19'> 
                            <td id ='td_19'>16.	Used needles to take drugs, steroids, or anything not prescribed by your doctor?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 19, 1, "N")} style={{ float: "left"}} choices={YesNo}  source="f_used_needle" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_20' > 
                            <td id ='td_20'>17. Had sexual contact with anyone who has ever used needles to take drugs or steroids, or anything not prescribed by their doctor?</td><td > <SelectInput  onChange={value => showNext(value.target.value, 20, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_sex_contact_used_needle" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_21'> 
                            <td id ='td_21'>18.	Female Donors: Had sexual contact with a male who had sexual contact with another male in the past 3 months?</td><td> <SelectInput style={{ float: "left"}} choices={YesNoExt}  onChange={value => showNext(value.target.value, 21, 1, "N")}  source="f_female_male_male" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_22'> 
                            <td id ='td_22'>19.	Gotten a tattoo or had one touched-up?</td><td > <SelectInput  onChange={value => showNext(value.target.value, 22, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_tattoo" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_23'> 
                            <td id ='td_23'>20.	Had an ear or body piercing?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 23, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_piercing" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_24' > 
                            <td id ='td_24'>21.	Had or been treated for syphilis or gonorrhea?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 24, 2, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_syphillis" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_25' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;In the past <b>four months</b>, have you</td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_26'> 
                            <td id ='td_26'>22. Donated a double unit of red blood cells using an apheresis machine?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 26, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_double_unit" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_27'> 
                            <td id ='td_27'>23. Had surgery or a diagnostic, medical or dental procedure?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 27, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_surgery" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_28'> 
                            <td id ='td_28'>24. Had acupuncture?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 28, 2, "N")} style={{ float: "left"}} choices={YesNo}  source="f_acupuncture" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_29' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;In the past <b>six months</b>, have you</td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_30'> 
                            <td id ='td_30'>25. Female Donors: been pregnant or are you pregnant now?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 30, 2, "N")}  style={{ float: "left"}} choices={YesNoExt}  source="f_pregnant" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_31' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;In the past <b>12 months</b>, have you</td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_32'> 
                            <td id ='td_32'>26. Received during surgery bone, tissue or skin?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 32, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_received_tissue" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_33'> 
                            <td id ='td_33'>27.	Had sexual contact with a person who has hepatitis?</td><td > <SelectInput  onChange={value => showNext(value.target.value, 33, 1, "N")} style={{ float: "left"}} choices={YesNo}  source="f_sex_hep" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_34'> 
                            <td id ='td_34'>28.	Been in juvenile detention, lockup, jail, or prison for 72 hours or more consecutively?</td><td> <SelectInput onChange={value => showNext(value.target.value, 34, 2, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_jail" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_35' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;From <b>1980 through 1996</b>, did you</td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_36'> 
                            <td id ='td_36'>29.	Spend time that adds up to 3 months or more in England, Northern Ireland, Scotland, Wales, the Isles of Man, the Channel Islands, Gibraltar, or the Falkland Islands?</td>
                            <td > <SelectInput onChange={value => showNext(value.target.value, 36, 2, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_uk" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_37' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;From <b>1980 through 2001</b>, did you</td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_38'> 
                            <td id ='td_38'>30.	Spend time that adds up to 5 years or more in France or Ireland? Time spent in Ireland does not include time spent in Northern Ireland which is part of the United Kingdom?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 38, 2, "N")} style={{ float: "left"}} choices={YesNo}  source="f_france" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_39' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;From <b>1980 through the present</b>, did you</td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_40'> 
                            <td id ='td_40'>31.	Receive a blood transfusion in France, Ireland, England, Northern Ireland, Scotland, Wales, the Isle of Man, the Channel Islands, Gibraltar, or the Falkland Islands?</td>
                            <td > <SelectInput  onChange={value => showNext(value.target.value, 40, 2, "N")} style={{ float: "left"}} choices={YesNo}  source="f_blood_uk" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_41' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;Have you <b>EVER</b></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_42'> 
                            <td id ='td_42'>32.	Had a positive test for HIV?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 42, 1, "N")} style={{ float: "left"}} choices={YesNo}  source="f_had_hiv" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_43'> 
                            <td id ='td_43'>33.	Had a transplant such as an organ or bone marrow?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 43, 1, "N")} style={{ float: "left"}} choices={YesNo}  source="f_had_transplant" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_44'> 
                            <td id ='td_44'>34.	Received a dura mater (or brain covering) graft?</td><td> <SelectInput onChange={value => showNext(value.target.value, 44, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_graft" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_45'> 
                            <td id ='td_45'>35.	Had any type of cancer, including leukemia?</td><td> <SelectInput onChange={value => showNext(value.target.value, 45, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_had_cancer" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_46'> 
                            <td id ='td_46'>36.	Had any problem with your heart or lungs?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 46, 1, "N")} style={{ float: "left"}} choices={YesNo}  source="f_prob_heart" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_47'> 
                            <td id ='td_47'>37.	Had any problem with your liver or kidneys?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 47, 1, "N")} style={{ float: "left"}} choices={YesNo}  source="f_prob_liver" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_48'> 
                            <td id ='td_48'>38. Had a bleeding condition or a blood disease?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 48, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_had_bleeding" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_49'> 
                            <td id ='td_49'>39.	Had a transplant or other medical procedure that involved being exposed to live cells, tissues or organs from an animal (xenotransplant)?</td>
                            <td> <SelectInput  onChange={value => showNext(value.target.value, 49, 1, "N")} style={{ float: "left"}} choices={YesNo}  source="f_animal" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_50'> 
                            <td id ='td_50'>40. Male Donors: Have you ever had sexual contact with another male?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 50, 1, "N")}  style={{ float: "left"}} choices={YesNoExt}  source="f_sex_male_male" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_51'> 
                            <td id ='td_51'>41. Have you ever had any type of nervous system disease?</td><td> <SelectInput onChange={value => showNext(value.target.value, 51, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_nervous" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_52'> 
                            <td id ='td_52'>42. Have you ever had a history of recurrent episodes of fainting?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 52, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_fainting" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_53'> 
                            <td id ='td_53'>43. Have you ever had a history of seizures or convulsions?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 53, 1, "N")}  style={{ float: "left"}} choices={YesNo}  source="f_seizures" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_54'> 
                            <td id ='td_54'>44. Have you ever been diagnosed with diabetes?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 54, 1, "N")} style={{ float: "left"}} choices={YesNo}  source="f_diabetes" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_55'> 
                            <td id ='td_55'>45. Have you ever been diagnosed with any other serious active, chronic, or relapsing disease?</td>
                            <td> <SelectInput  onChange={value => showNext(value.target.value, 55, 1, "N")} style={{ float: "left"}} choices={YesNo}  source="f_chronic" label=""   /></td>
                        </tr>
                         <tr  style={{display: 'none'}}  id= 'hq_56'> 
                            <td id ='td_56'>46. Have any of your relatives had Creutzfeld-Jakob disease?</td><td> <SelectInput  onChange={value => showNext(value.target.value, 56, 0, "N")} style={{ float: "left"}} choices={YesNo}  source="f_relative" label=""   /></td>
                        </tr>
                    
                <tr>
                    <td colSpan="2" ><b>Comments:</b></td>
                </tr>
                <tr>
                    <td colSpan="2" ><TextInput source="f_comments" label=""  rowsMax={4} multiline fullWidth /></td>
                </tr>
                <tr>
                    <td colSpan="2" ><b>Acknowledgment:</b></td>
                </tr>
                <tr>
                    <td colSpan="2" >
                    1.	I have reviewed the educational materials regarding infections that can be transmitted by my donation, such as, Syphilis, HIV, Hepatitis B and C.<br />
                    2.	I agree not to donate if my donation could result in a potential risk to people who receive plasma products.<br />
                    3.	A sample of my blood will be tested for infections that can be transmitted by my donation, such as, Syphilis, HIV, Hepatitis B and C.<br />
                    4.	I understand you will attempt to notify me if for any reason I cannot donate and records will be maintained indicating the reason for the deferral and the deferral time period.<br />
                    5.	I have reviewed the information regarding the potential risks and hazards of donating Source Plasma.<br />
                    6.	I have been given the opportunity to ask questions and understand that I may withdraw from the donation procedure at any time.<br />
                    </td>
                </tr>
                <tr>
                    <td colSpan="2" >
                        <table width="100%">
                        <tr>
                            <td>Donor Signature: </td><td><Sign setSignatureValue={setQDonSignatureValue} /></td>
                            <td>Date: </td><td><DateInput source="f_don_sign_date" label="" locales="en-us"></DateInput></td>
                        </tr>
                        <tr>
                            <td>Medical Examiner: </td><td><Sign setSignatureValue={setQExaminerSignatureValue}  /></td>
                            <td>Date: </td><td><DateInput source="f_med_exam_date" label="" locales="en-us"></DateInput></td>
                        </tr>
                        <tr>
                            <td>QA Review Initials: </td><td><SanitizedTextInput source="f_qa_init" label="" /></td>
                            <td>Date: </td><td><DateInput source="f_qa_date" label="" locales="en-us"></DateInput></td>
                        </tr>
                        </table>
                    </td>
                </tr>
            </tbody>
            </table>
        
            </FormTab>
             
            {IsNot2ndPhysical(props.location.ssn) && 
            <FormTab label="Anatomic" id="anato" >   
                <Allergies ssn={ (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn} />   
                <Table  className={classes.formTable}  >
                    <TableBody  >  
                        <TableRow>
                               
                                <TableCell  align="center" bgcolor="silver"  colSpan='2'></TableCell>
                                <TableCell  align="center" bgcolor="silver" > <b>Examination of Anatomical Area</b></TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 1.'}</TableCell>
                                <TableCell  ><SelectInput source='appearance'  label="" choices={anato} onChange={value => AnotoValidate(value.target.value, 1)} /></TableCell>
                                <TableCell id='tc_1' ><b>{'General appearance:'}</b>{'Awake, alert and oriented and in no apparent distress, emotionally stable.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 2.'}</TableCell>
                                <TableCell  ><SelectInput source='head'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 2)} /></TableCell>
                                <TableCell  id='tc_2'><b>{'Head:'}</b>{'Normocephalic, atraumatic, symmetrical, no scars.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 3.'}</TableCell>
                                <TableCell  ><SelectInput source='eyes'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 3)} /></TableCell>
                                <TableCell  id='tc_3'><b>{'Eyes:'}</b>{'White conjunctiva, pupils equal round and reactive to light and accommodation, extraocular muscles intact bilaterally. No sclera icterus.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 4.'}</TableCell>
                                <TableCell  ><SelectInput source='ears'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 4)} /></TableCell>
                                <TableCell id='tc_4'><b>{'Ears:'}</b>{'Symmetrical without any tenderness, discharged or erythema in external canals bilaterally. Tympanic memberanes are clear without any erythema bilaterally.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 5.'}</TableCell>
                                <TableCell  ><SelectInput source='nose'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 5)} /></TableCell>
                                <TableCell  id='tc_5'><b>{'Nose:'}</b>{'Symmetrical without any tenderness or discharge. No inflammation or nasal mucosa bilaterally. No septal perforation.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 6.'}</TableCell>
                                <TableCell  ><SelectInput source='mouth'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 6)} /></TableCell>
                                <TableCell id='tc_6'><b>{'Mouth and Throat:'}</b>{'Clear without erythema or exudates in posterior oropharynx. Pink mucosa on tongue and tonsils (if present). No ulcerations or needle marks present.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 7.'}</TableCell>
                                <TableCell  ><SelectInput source='neck'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 7)} /></TableCell>
                                <TableCell id='tc_7'><b>{'Neck /Lymphatic:'}</b>{'No scars noted. No masses palpated. No thyromegaly. No enlarged or tender nodules. No cervical, posterior auricular or supraclavicular lymphadenopathy.  No axillary adenopathy.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 8.'}</TableCell>
                                <TableCell  ><SelectInput source='heart'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 8)} /></TableCell>
                                <TableCell id='tc_8'><b>{'Heart:'}</b>{'Regular rate and rhythm with no murmurs, gallops, rubs or clicks. No additional heart sounds.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 9.'}</TableCell>
                                <TableCell  ><SelectInput source='lungs'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 9)} /></TableCell>
                                <TableCell id='tc_9'><b>{'Lungs:'}</b>{'Clear to auscultation in all fields bilaterally. No wheezes, rales or rhonchi.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 10.'}</TableCell>
                                <TableCell  ><SelectInput source='abdomen'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 10)} /></TableCell>
                                <TableCell id='tc_10'><b>{'Abdomen:'}</b>{'No scars noted. Soft, non-tender. No guarding or rebound tenderness. No palpable masses. No hepato-splenomegaly.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 11.'}</TableCell>
                                <TableCell  ><SelectInput source='neurological'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 11)} /></TableCell>
                                <TableCell id='tc_11'><b>{'Neurological:'}</b>{'Normal gait and balance. No tremors. Mental status and speech appropriate. Deep tendon reflexes are symmetric bilaterally. No facial asymmetries.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 12.'}</TableCell>
                                <TableCell  ><SelectInput source='muscul'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 12)} /></TableCell>
                                <TableCell id='tc_12'><b>{'Musculoskeletal/Extremities:'}</b>{'No obvious deformities noted.  No edema.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 13.'}</TableCell>
                                <TableCell  ><SelectInput source='skin'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 13)} /></TableCell>
                                <TableCell id='tc_13'><b>{'Skin:'}</b>{'No suspicious needle marks. No suspicious lesions. No infections, rashes, bruises, scarring or masses.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell colSpan='3'><TextInput source="physical_exam_comments" label="Comments" rowsMax={4} multiline fullWidth /></TableCell>
                        </TableRow> 
                    </TableBody>
                </Table>
                <Table   className={classes.formTable} >                           
                    <TableBody>                 
                        <TableRow>
                            <TableCell  align="left" colSpan="2">{'High Risk Assessment Quiz Completed Initial:'}</TableCell>
                            <TableCell  align="left"><SanitizedTextInput source='quiz_comp_initial' label=''/></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  align="left">{'Donor Suitable for Donation?'}<SelectInput source="suitable" label="" choices={YesNo}  validate={required()}/></TableCell>
                            <TableCell><SanitizedTextInput source="suitable_initial"  label="Initial" /></TableCell>
                            <TableCell><DateInput source="suitable_date"  label="Date" locales="en-us"/></TableCell>
                        </TableRow> 
                        <TableRow>
                            <TableCell  align="left" >{'Donor Signature:'}<Sign setSignatureValue={setADonSignatureValue} /></TableCell>
                            <TableCell  align="left">{"Examinor's Signature:"}<Sign setSignatureValue={setAExaminerSignatureValue}  /></TableCell>
                            <TableCell ><DateInput source="quiz_exam_date"  label="Date" locales="en-us"/></TableCell>
                        </TableRow> 
                    </TableBody>
                </Table>   
                <Referrls ssn={(props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn}  />
            </FormTab>
            }
            {IsNot2ndPhysical(props.location.ssn) && 
            <FormTab label="Tattoo" id="tattoo">  
                <Allergies ssn={ (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn} />    
                <Table   className={classes.formTable} >
                <TableBody  > 
                    <TableRow > 
                        <TableCell colSpan="3" ><TextInput source="tattoo_desc" label="Description (Tattoo/Body Piercing)"  rowsMax={3} multiline fullWidth /></TableCell>                       
                    </TableRow > 
                    <TableRow > 
                        <TableCell  colSpan="3"><b>{'Donor Verification Statment:'}</b>{'This body map is an accurate representation of all my piercings (including closed piercings) gauging, '
                        + 'and/or tattoos, touch ups and/or brandings, and scarifications.  I agree to notify center staff if I receive any new tattoos, piercings, gauging,  brandings, or scarifications.'}
                         </TableCell>                       
                    </TableRow > 
                    <TableRow>
                        <TableCell>{"Donor's signature:"}<Sign setSignatureValue={setTDonSignatureValue} /></TableCell>
                        <TableCell>{"Examinor's Signature:"}<Sign setSignatureValue={setTExaminerSignatureValue}  /></TableCell>
                        <TableCell ><DateInput source="desc_exam_date"  label="Date" locales="en-us" /></TableCell>
                    </TableRow>
                </TableBody  > 
                </Table>
        
                <Table   className={classes.formTable} >
                <TableBody  > 
                    <TableRow > 
                        <TableCell ><b>Tattoo /Piercing image </b>(<font color="blue">Add</font>):<br />
                            <ImageInput source="tattoo_img" label="" accept="image/*" minSize={0} maxSize={2000000}>
                                <ImageField source="src" title="Tattoo" />
                            </ImageInput>
                        </TableCell>
                    </TableRow>
                </TableBody>
                </Table>
                <Referrls ssn={(props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn}  />
            </FormTab>
            }

            {IsNot2ndPhysical(props.location.ssn) && 
            <FormTab label="Medications" id="medic"> 
                <Allergies ssn={ (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn} />     
                <ArrayInput source="medications" label='Medication(s)'>
                    <SimpleFormIterator>
                        <TextInput source='med_name' label = 'Medication Name' formClassName={classes.inlineBlock}/>
                        <BooleanInput source='med_accept' label = 'Is this Medication acceptable?' formClassName={classes.inlineBlock} />
                        <DateInput source="med_s_date" label='Start Date'  locales="en-us" formClassName={classes.inlineBlock}/>
                        <TextInput source="med_s_init" label='Initial' formClassName={classes.inlineBlock} />
                        <DateInput source="med_s_init_date" label='Date' locales="en-us" formClassName={classes.inlineBlock} />
                        <DateInput source="med_e_date" label='Stop Date' locales="en-us" formClassName={classes.inlineBlock}/>
                        <TextInput source="med_e_init" label='Initial' formClassName={classes.inlineBlock}/>
                        <DateInput source="med_e_init_date" label='Date' locales="en-us" formClassName={classes.inlineBlock}/>
                        <TextInput source="med_comments" label='Comments' formClassName={classes.inlineBlock} rowsMax={3} multiline />
                        <TextInput source="med_qa_review" label='QA Review' formClassName={classes.inlineBlock} rowsMax={3} multiline />
                    
                    </SimpleFormIterator>
                </ArrayInput>
                <Table   className={classes.formTable} >
                    <TableBody  > 
                        <TableRow > 
                            <TableCell>{'Donor Suitable for Donation?'}<SelectInput source="suitable" label="" choices={YesNo}  validate={required()}/></TableCell>
                            <TableCell><TextInput source="suitable_initial"  label="Initial" /></TableCell>
                            <TableCell><DateInput source="suitable_date"  label="Date" locales="en-us"/></TableCell>
                        </TableRow>
                        <TableRow > 
                            <TableCell>{'QA Reviwe Initial'}<TextInput source="med_qa_init" label=""/></TableCell>
                            <TableCell colSpan="2"><DateInput source="med_qa_date"  label="Date" locales="en-us"/></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Referrls ssn={(props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn}  />
             </FormTab>
             }

            {IsNot2ndPhysical(props.location.ssn) && 
             <FormTab label="Consent" id="consent">  
                <Allergies ssn={ (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn} />   
                <div style={{width: "100%"}} align="center" >
                    <h2>Plasmapheresis Informed Consent</h2>
                    <Iframe source={REACT_APP_CONSENT_URL}  />
                </div>
                <Table className={classes.formTable} >
                    <TableBody>
                        <TableRow>
                            <TableCell>Donor Signature: </TableCell><TableCell align="left"><Sign setSignatureValue={setCDonSignatureValue} /></TableCell>
                            <TableCell>Date: </TableCell><TableCell align="left"><DateInput source="pla_don_sign_date" label="" locales="en-us" /></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Medical Examiner Signature: </TableCell><TableCell align="left"><Sign setSignatureValue={setTExaminerSignatureValue}  /></TableCell>
                            <TableCell>Date: </TableCell><TableCell align="left"><DateInput source="mad_exam_sign_date" label="" locales="en-us" /></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Table className={classes.formTable} >
                    <TableBody>
                        <TableRow > 
                            <TableCell>Donor Suitable for Donation?</TableCell><TableCell  align="left"><SelectInput source="suitable" label="" choices={YesNo}  validate={required()}/></TableCell>
                            <TableCell>Initial:</TableCell><TableCell  align="left"><TextInput source="suitable_initial"  label="" /></TableCell>
                            <TableCell>Date:</TableCell><TableCell  align="left"><DateInput source="suitable_date"  label="" locales="en-us"/></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Referrls ssn={(props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn}  />
               
             </FormTab>
             }
        </TabbedForm>
       
    </Create>
    </ErrorBoundary>
);

export default withStyles(editStyles)(PhysicalCreate);